export default __webpack_public_path__ + "static/media/reading.97f4f41a.svg";